import { cn } from "@/lib/utils";

const PauseIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden
    viewBox="0 0 24 24"
    fill="currentColor"
    className={cn("h-6 w-6", className)}
  >
    <rect x="7.25" y="6" width="3" height="12" rx="1.5" />
    <rect x="13.75" y="6" width="3" height="12" rx="1.5" />
  </svg>
);

export default PauseIcon;
